import { useEffect } from 'react';
import ReactDOM from 'react-dom';

let openPortalCount = 0;
let previousBodyOverflow = '';

export default function ModalPortal({ children }) {
  const el = document.body;
  useEffect(() => {
    if (openPortalCount === 0) previousBodyOverflow = document.body.style.overflow;
    openPortalCount += 1;
    document.body.style.overflow = 'hidden';
    return () => {
      openPortalCount = Math.max(0, openPortalCount - 1);
      if (openPortalCount === 0) document.body.style.overflow = previousBodyOverflow;
    };
  }, []);
  return ReactDOM.createPortal(children, el);
}
